import React from 'react';

interface CardsProps extends React.HTMLAttributes<HTMLDivElement> {
  title?: string;
  classname?: string;
  childClassName?: string;
  bottomButton?: React.ReactNode;
  children: React.ReactNode;
  variant?: "primary" | "secondary" | "grayCard" | "danger";
  onClick?: () => void;
  loading?: boolean;
  style?: React.CSSProperties;
}

function Cards({ title, classname = '', childClassName = '', bottomButton = '', children, variant = "primary", onClick, loading = true, style, ...rest }: CardsProps) {
  const variants = {
    primary: `border border-solid shadow-sm bg-[#F5FAF7] border-green-200 ${bottomButton ? '' : 'p-4'}`,
    secondary: `gap-0.5rem md:rounded-[1rem] ${bottomButton ? '' : 'p-2'} md:border md:border-solid md:border-[#e9e9eb] bg-white md:shadow-[0_0.0625rem_0.125rem_0_#0a0c120c]`,
    grayCard: "bg-gray-100",
    danger: "bg-red-500 hover:bg-red-600 text-white",
  }

  return (
    <div className={`flex-col flex gap-2 md:rounded-2xl ${variants[variant]} ${classname} ${onClick ? 'cursor-pointer' : ''}`} onClick={onClick} style={style} {...rest}>
      {title &&
        <h1 className="text-xl font-extrabold tracking-tight leading-8 text-neutral-700">
          {title}
        </h1>
      }
      <div className={`flex gap-1 ${childClassName}`}>
        {children}
      </div>
      {bottomButton && <div className="flex border-t p-5 border-solid justify-end border-gray-300" >{bottomButton}</div>}
    </div>
  )
}

export default Cards